import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { layoutPreviewDescriptor } from './descriptor.js';

export const layoutPreviewCatalogEntry = {
  descriptor: layoutPreviewDescriptor,
  availability: 'diagnostic',
  load: async () => (await import('./layout-preview.js')).layoutPreviewDefinition,
} satisfies AvailableGameCatalogEntry;
